import type { WidgetInterruptEvent } from '@core/widgets/interrupts/types'

import type { IWidgetState } from './types'

const defaultCallback = () => Promise.resolve()

/**
 *
 */
export function actionsSelector(state: IWidgetState) {
  return state.actions
}

/**
 *
 */
export function appContextSelector(state: IWidgetState) {
  return state.appContext
}

/**
 *
 */
export function paramsSelector(state: IWidgetState) {
  return state.params
}

/**
 *
 */
export function embedConfigParamsSelector(state: IWidgetState) {
  return state.embedConfigParams
}

/**
 *
 */
export function paramsLangSelector(state: IWidgetState) {
  return state.params.lang
}

/**
 *
 */
export function videosSelector(state: IWidgetState) {
  return state.navigation.map((id) => state.videos[id])
}

/**
 * @returns widget integration callbacks
 */
export function widgetInterruptionEventCallbackSelector(
  event: WidgetInterruptEvent,
) {
  return function (state: IWidgetState) {
    return state.interruptionCallbacks?.[event] ?? defaultCallback
  }
}
